import { t } from 'i18next';
import checkoutRepository from '../checkout/checkoutRepository';
import subjectsRepository from '../subjects/subjectsRepository';
import teachersRepository from './teachersRepository';

import { currencyToSymbol } from '@src/utils/pricing';

export default class TeacherPagePresenter {
  async getTeacherById(id) {
    const teacherPm = await teachersRepository.getTeacherDetailsInfoById(id);
    const subjectsPm = subjectsRepository.getSubjects();

    const teacherVm = {
      id: teacherPm.id,
      name: teacherPm.name,
      slug: teacherPm.slug,
      avatarUrl: teacherPm.avatarUrl,
      description: teacherPm.description,
      ratingCount: teacherPm.rating.count,
      rating: teacherPm.rating.width,
      isFeatured: teacherPm.isFeatured,
      stats: [
        {
          icon: 'price',
          value: `${teacherPm.price} ${currencyToSymbol[teacherPm.currency]}`,
          label: t('oneLessonPrice'),
          price: teacherPm.price,
          currency: currencyToSymbol[teacherPm.currency],
        },
        {
          icon: 'lesson',
          value: teacherPm.stats.lessonCount,
          label: t('completedLessons'),
        },
        {
          icon: 'message',
          value: teacherPm.stats.messageCount,
          label: t('messages'),
        },
      ],
      videoUrl: teacherPm.videoUrl,
      hasSubjects: !!teacherPm?.subjects?.length,
      subjects:
        teacherPm.subjects &&
        teacherPm.subjects.map(
          ({
            subjectId,
            qualification,
            taughtForClasses,
            taughtForStudents,
            taughtForAdults,
          }) => {
            let mergeSubject =
              subjectsPm.find((subject) => subject.uniqueId === subjectId) ||
              {};
            mergeSubject.qualification = qualification;
            mergeSubject.taughtForClasses = taughtForClasses;
            mergeSubject.taughtForStudents = taughtForStudents;
            mergeSubject.taughtForAdults = taughtForAdults;
            return mergeSubject;
          }
        ),
      calendar: teacherPm.calendar,
      feedback: teacherPm.feedback || [],
      teachingLanguages: teacherPm.teachingLanguages,
    };

    return teacherVm;
  }

  async bookALesson() {
    checkoutRepository.toggleModal({ type: 'lesson' });
  }
}
